import ICustomTelemetryHandler from './ICustomTelemetryHandler';
import IEnvelope = Microsoft.ApplicationInsights.IEnvelope;

class IgnoreExternalScriptErrorHandler implements ICustomTelemetryHandler {
  public tryHandle(envelope: IEnvelope) {
    if (envelope.data.baseType !== 'ExceptionData') {
      return false;
    }

    const { baseData } = envelope.data;

    return baseData.exceptions.any(
      (e: { typeName: string; message: string }) => e.typeName === 'Error' && e.message === 'Script error.',
    );
  }
}

export default IgnoreExternalScriptErrorHandler;
